import type { ActivationAlertsMetricsNewsDetailData } from "@similarweb/pro-api-client";

import type { ExtendedNewsMetricsData } from "../components/table/types";
import { computeLeaders } from "../utils/computeLeaders";

export const transformNewsMetricsData = ({
    data,
    icons,
    primaryDomain,
}: {
    data: ActivationAlertsMetricsNewsDetailData;
    icons: Record<string, string> | undefined;
    primaryDomain?: string;
}): ExtendedNewsMetricsData[] => {
    const leaders = computeLeaders(data);

    return data.map((row) => ({
        domain: {
            icon: icons?.[row.domain],
            isPrimary: row.domain === primaryDomain,
            value: row.domain,
        },
        mentions: {
            ...row.mentions,
            isLeader: leaders.mentions.has(row.domain),
        },
        pressReleases: {
            ...row.pressReleases,
            isLeader: leaders.pressReleases.has(row.domain),
        },
        stories: {
            ...row.stories,
            isLeader: leaders.stories.has(row.domain),
        },
    }));
};
